import { throttle } from 'lodash';

export default {
  data() {
    return {
      // 存储节流函数的实例
      throttledFunctions: {}
    };
  },
  methods: {
    /**
     * 创建节流函数
     * @param {Function} func 需要节流的函数
     * @param {String} key 唯一标识，用于区分不同的节流函数
     * @param {Number} wait 节流等待时间，默认500ms
     * @returns {Function} 节流处理后的函数
     */
    createThrottledFunction(func, key, wait = 500) {
      // 如果已存在该key的节流函数，则直接返回
      if (this.throttledFunctions[key]) {
        return this.throttledFunctions[key];
      }

      // 创建新的节流函数
      const throttled = throttle((...args) => {
        func.apply(this, args);
      }, wait, {
        leading: true,  // 第一次触发是否立即执行
        trailing: false, // 最后一次触发后是否执行
      });

      // 存储节流函数实例
      this.throttledFunctions[key] = throttled;
      return throttled;
    }
  },
  beforeDestroy() {
    // 组件销毁前，取消所有节流函数，防止内存泄漏
    Object.values(this.throttledFunctions).forEach(throttledFunc => {
      throttledFunc.cancel();
    });
    this.throttledFunctions = {};
  }
};